// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2vrhb","selects":"Documents_selects__2uf3S"};